export default function promisifyActions(dispatchActions) {
  return (dispatch) =>
    dispatchActions(
      (action) =>
        new Promise((resolve, reject) => {
          dispatch({
            ...action,
            ...action.payload,
            resolve,
            reject,
          });
        }),
    );
}
